<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
               [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
               [mode]="(isHandset$ | async) ? 'over' : 'side'"
               [opened]="(isHandset$ | async) === false">
    <mat-toolbar>Menu</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item href="#" [routerLink]="['/']" [routerLinkActive]="['active']"
         [routerLinkActiveOptions]="{exact:true}"><mat-icon matListIcon>home</mat-icon><span matLine>Home</span></a>
    </mat-nav-list>
    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Amaia
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-nav-list>
        <a mat-list-item [routerLink]="['/amaia/users']" [routerLinkActive]="['active']"
           [routerLinkActiveOptions]="{exact:true}">Users</a>
        <a mat-list-item [routerLink]="['/amaia/roles']" [routerLinkActive]="['active']"
           [routerLinkActiveOptions]="{exact:true}">Roles</a>
        <a mat-list-item [routerLink]="['/amaia/permissions']" [routerLinkActive]="['active']"
           [routerLinkActiveOptions]="{exact:true}">Permissions</a>
      </mat-nav-list>
    </mat-expansion-panel>
    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title>
          I don't care
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-nav-list>
        <a mat-list-item [routerLink]="['/idc/posts']" [routerLinkActive]="['active']"
           [routerLinkActiveOptions]="{exact:true}">Posts</a>
      </mat-nav-list>
    </mat-expansion-panel>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <h1 [routerLink]="['/']" >Whistler</h1>
      <span class="fill-space"></span>
      <div>
        <button class="user" mat-button [matMenuTriggerFor]="userMenu">
          <img class="avatar" src="{{user.avatar}}" alt="avatar">
          <strong>{{user.name}}</strong>
        </button>
        <mat-menu #userMenu xPosition="before">
          <button mat-menu-item (click)="logout()">
            <mat-icon>keyboard_tab</mat-icon>
            <span>Logout</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>
    <div class="content">
      <ng-content></ng-content>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
